( function( $ ) {

    var Attribution = {
        GetParamsObject: function() {
            var params_values = {};

            var document_referrer = document.referrer;
            var is_google = document_referrer.match(/^https?:\/\/(?:www\.)?google(?:\.[a-z]{2,3}){1,2}\/$/i );
            var is_bing   = document_referrer == 'https://www.bing.com/';

            if ( VCUtils.GetQueryVar( 'invite' ) == false && document_referrer && ( is_google || is_bing ) ) {

                params_values[ 'invite' ] = is_google ? 'Organic_Google' : 'Organic_Bing';

            } else {

                var params_names = [ 'invite' , 'directory_token' , 'lang' , 'utm_source' , 'utm_medium' , 'utm_campaign' , 'utm_term' , 'utm_content', 'sub_id' ];

                params_values = params_names.reduce(
                    function(accumulator, name){
                        var queryVarValue = VCUtils.GetQueryVar( name );
                        if( queryVarValue )
                            accumulator[name] = queryVarValue;
                        return accumulator;
                    }, {}
                );

            }

            if ( !$.isEmptyObject( params_values ) )
                Attribution.SaveParamsToCookie( params_values );
        },

        SaveParamsToCookie: function( current_params ) {
            var attribution_cookie = JSON.parse( VCUtils.GetCookie( 'attribution_params' ) ) || [];

            current_params.time_stamp = new Date();
            attribution_cookie.push( current_params );

            VCUtils.SetCookie( 'attribution_params' , JSON.stringify( attribution_cookie ), '/' );
        }
    };

    Attribution.GetParamsObject();

})(jQuery);
